// extracted by mini-css-extract-plugin
export default {"input":"Input_input__1eas0","form":"Input_form__9C6en","button":"Input_button__hL79a"};